/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { MyInjector } from "@src/app/app.module";
import { Cycle } from "@src/app/model/cycle";
import { ActionColor, IFormAction } from "@src/app/shared/form/form.component";
import { CycleService } from "@src/app/modules/budget/cycle.service";
import { CurrentUserService } from "@src/app/modules/user/current-user.service";

export class SquashPreviousAction implements IFormAction {
    name = $localize`Squash Previous`;
    color: ActionColor = 'primary';
    show = true;
    icon = 'compress';
    approvalNeeded = true;
    disabled = false;
    approvalText = "Are you sure you want to delete all prior cycles and move their transactions into the first period of this cycle?";
    tipText = '';
    currentUserSvc = MyInjector.instance.get(CurrentUserService);
    cycleSvc = MyInjector.instance.get(CycleService);

    action(cycle: Cycle) {
        return this.cycleSvc.statusChange(cycle, 'squashPrevious');
    }

    //  setup(serviceRequest: ServiceRequest) {
    setup() {
        if (this.currentUserSvc.hasUber()) {
            this.show = true;
        } else {
            this.show = false;
        }

    }
}
